import { Injectable } from '@angular/core';
import { format, toZonedTime } from 'date-fns-tz';

@Injectable({
  providedIn: 'root'
})
export class DateService {

  private readonly TIMEZONE = 'America/Sao_Paulo';

  getCurrentDate(): Date {
    return toZonedTime(new Date(), this.TIMEZONE);
  }

  toSaoPauloTime(date: Date): Date {
    return toZonedTime(date, this.TIMEZONE);
  }

  formatDate(date: Date, formatStr: string = 'yyyy-MM-dd HH:mm:ss'): string {
    return format(toZonedTime(date, this.TIMEZONE), formatStr, { 
      timeZone: this.TIMEZONE 
    });
  }
  
}
